var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a;
import { actions } from "store";
import { boxAnchorEntityName } from "3d/cardboard-box-entities";
import { getNodesMountedOnGripFrame } from "3d/grip-frame";
export var EntityType;
(function (EntityType) {
    EntityType["ATTACHMENT"] = "attachment";
    EntityType["NODE"] = "node";
    EntityType["EDGE"] = "edge";
    EntityType["BOX"] = "box";
    /* The frame the cups are mounted on — dragging it moves all the cups. */
    EntityType["FRAME"] = "frame";
    EntityType["OTHER"] = "other";
})(EntityType || (EntityType = {}));
var selectedNodeIdsWithPicked = function (picked, context) {
    var ids = __spreadArray([], __read(context.selectedIds), false);
    if (!ids.includes(picked.id))
        ids.push(picked.id);
    return ids;
};
var nodeBehavior = {
    collectDragTargets: function (picked, _a) {
        var app = _a.app, selectedIds = _a.selectedIds;
        var targets = [picked.entity];
        selectedIds.forEach(function (id) {
            if (id === picked.id)
                return;
            var entity = app.root.findByName(id);
            if (entity)
                targets.push(entity);
        });
        return targets;
    },
    commitDrag: function (picked, _a) {
        var app = _a.app, dispatch = _a.dispatch, nodes = _a.nodes, selectedIds = _a.selectedIds;
        var persistNodePosition = function (nodeId, entity) {
            var position = entity.getPosition();
            dispatch(actions.setNodePosition({
                position: { x: position.x, y: position.y, z: position.z },
                nodeId: nodeId,
            }));
        };
        persistNodePosition(picked.entity.name, picked.entity);
        // A multi-select drag moved every selected node by the same offset.
        selectedIds.forEach(function (id) {
            if (id === picked.id || !nodes[id])
                return;
            var entity = app.root.findByName(id);
            if (entity)
                persistNodePosition(id, entity);
        });
    },
    // A node click runs the picker's select/multi-select logic.
    handlesSelection: false,
    movingNodeIds: selectedNodeIdsWithPicked,
};
var boxBehavior = {
    collectDragTargets: function (picked, _a) {
        var app = _a.app;
        var targets = [picked.entity];
        // Move the anchor alongside the visual root: it is centred on the box's
        // logical position (the visual root's origin is a corner), so it is also
        // what the drag is persisted from.
        var anchor = app.root.findByName(boxAnchorEntityName(picked.id));
        if (anchor)
            targets.push(anchor);
        return targets;
    },
    commitDrag: function (picked, _a) {
        var app = _a.app, dispatch = _a.dispatch;
        var anchor = app.root.findByName(boxAnchorEntityName(picked.id));
        var anchorPosition = anchor === null || anchor === void 0 ? void 0 : anchor.getPosition();
        if (!anchorPosition)
            return;
        dispatch(actions.setCardboardBoxPosition({
            id: picked.id,
            position: { x: anchorPosition.x, z: anchorPosition.z },
        }));
    },
    // A click without a drag selects the box (shows its edit overlay + panel).
    clickWithoutDrag: function (picked, _a) {
        var dispatch = _a.dispatch;
        dispatch(actions.selectBox(picked.id));
    },
    handlesSelection: true,
    movingNodeIds: selectedNodeIdsWithPicked,
};
/* The ids of the nodes the frame carries (see `getNodesMountedOnGripFrame`). */
var gripFrameNodeIds = function (context) {
    return getNodesMountedOnGripFrame(context).map(function (node) { return node.id; });
};
var frameBehavior = {
    /* The frame is rigid: every cup travels with it, keeping their spacing,
     * along with the tube connections right behind them. The rest of the network
     * stays where it is (see `getNodesMountedOnGripFrame`). */
    collectDragTargets: function (picked, context) {
        var targets = [picked.entity];
        gripFrameNodeIds(context).forEach(function (nodeId) {
            var nodeEntity = context.app.root.findByName(nodeId);
            if (nodeEntity)
                targets.push(nodeEntity);
        });
        return targets;
    },
    /* The frame has no stored position — it is derived from the cups — so what
     * is saved is the move itself, applied to all it carries. A moved frame ends up
     * selected, like a clicked one, so its turn control is right there: the
     * press that started the drag cleared the selection, which keeps the control
     * from lagging behind at the old spot while the frame travels. */
    commitDrag: function (picked, _a) {
        var dispatch = _a.dispatch, dragStart = _a.dragStart;
        if (!dragStart)
            return;
        var moved = picked.entity.getPosition();
        dispatch(actions.moveGripFrame({
            delta: { x: moved.x - dragStart.x, z: moved.z - dragStart.z },
        }));
        dispatch(actions.selectGripFrameForEditing());
    },
    // A plain click selects the frame, which brings up its turn control.
    clickWithoutDrag: function (_picked, _a) {
        var dispatch = _a.dispatch;
        dispatch(actions.selectGripFrameForEditing());
    },
    handlesSelection: true,
    // Every tube out to the frame has a moving end, so hide those for the drag.
    movingNodeIds: function (_picked, context) { return gripFrameNodeIds(context); },
};
export var dragBehaviors = (_a = {},
    _a[EntityType.NODE] = nodeBehavior,
    _a[EntityType.BOX] = boxBehavior,
    _a[EntityType.FRAME] = frameBehavior,
    _a);
export var isDraggable = function (type) { return dragBehaviors[type] != null; };
